import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const guestbookApi = {
  list: () => api.get('/guestbook').then((r) => r.data),
  verifyPassword: (password) =>
    api.post('/guestbook/verify', { password }).then((r) => r.data),
  create: ({ password, name, message, rating }) =>
    api
      .post('/guestbook', { password, name, message, rating })
      .then((r) => r.data),
};

export const contactApi = {
  send: ({ name, email, phone, subject, message }) =>
    api
      .post('/contact', { name, email, phone, subject, message })
      .then((r) => r.data),
};
